import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const scriptUrlMap = {
  cn: 'https://assets.salesmartly.com/js/project_58763_61350_1714288626.js',
  en: 'https://plugin-code.salesmartly.com/js/project_58763_204956_1734343625.js'
}

export default function ChatBots() {
  let { i18n } = useTranslation();
  
  useEffect(() => {
    // 创建 script 标签
    const script = document.createElement('script');
    const scriptUrl = i18n.language === 'cn' ? scriptUrlMap.cn : scriptUrlMap.en;
    script.src = scriptUrl;
    script.async = true;

    // 将 script 标签插入到 body 中
    document.head.appendChild(script);

    // 清理：组件卸载时移除 script 标签
    return () => {
      document.head.removeChild(script);
    };
    
  }, [i18n.language]); 

};